<template>
  <el-card class="user-content-panel">
    <div slot="header">
      <span class="panel-header">默认地址管理</span>
      <el-button class="btn-red-plain btn-create" size="small" @click="showAddressCreate">添加新地址</el-button>
    </div>
    <div class="address-list" v-loading="listLoading">
      <el-card v-for="address in addressList" :key="address.addressId"
        shadow="never"
        class="address-card"
        :class="address.isDefault ? 'address-default' : ''">
        <el-row>
          <el-col :span="16" class="address-info">
            <el-row>
              <el-col :span="4">收 货 人 : </el-col>
              <el-col :span="20">{{ address.contactPerson }}</el-col>
            </el-row>
            <el-row>
              <el-col :span="4">联系方式 : </el-col>
              <el-col :span="20">{{ maskMobileNo(address.contactMobile) }}</el-col>
            </el-row>
            <el-row>
              <el-col :span="4">收货地址 : </el-col>
              <el-col :span="20">{{ composeAddressInfo(address) }}</el-col>
            </el-row>
          </el-col>
          <el-col :span="8" class="text-center address-opt">
            <el-button size="small" type="primary" @click="showAddressUpdate(address)">修改</el-button>
            <el-button size="small" class="btn-orange" @click="removeAddress(address)">删除</el-button>
            <el-button size="small" :class="address.isDefault ? 'btn-orange-plain' : 'btn-grey-plain'" @click="setDefault(address)">
              {{ address.isDefault ? '默认地址' : '设为默认' }}
            </el-button>
          </el-col>
        </el-row>
      </el-card>

      <div class="pag-row" v-if="addressList && addressList.length">
        <el-pagination
          background
          layout="total, prev, pager, next"
          :current-page="queryParam.page"
          :page-size="queryParam.pageSize"
          :total="total"
          @current-change="handleCurrentChange"
        />
      </div>

      <!-- <div class="address-list-search">
        <el-input v-model="queryParam.keyWord" class="search-input" placeholder="关键字搜索">
          <i slot="suffix" class="el-input__icon el-icon-search"></i>
        </el-input>
        <el-button type="danger" class="btn-red" @click="handleFilter">搜索</el-button>
      </div>

      <el-table class="address-table" :data="sdList" border stripe>
        <el-table-column prop="sdInfo" label="SD" width="150px" align="left"/>
        <el-table-column label="收货地址" align="left">
          <template v-if="sdList && sdList.length" slot-scope="scope">
            <span v-for="(item, index) in scope.row.baseAddressList" :key="item.addressId" class="address-item">
              {{ item.addressInfo }}
              <span class="divider" v-if="index < scope.row.baseAddressList.length - 1"></span>
            </span>
          </template>
        </el-table-column>
      </el-table> -->

      <!-- <div class="pag-row" v-if="sdList && sdList.length">
        <el-pagination
          background
          layout="total, prev, pager, next"
          :current-page="queryParam.page"
          :page-size="queryParam.pageSize"
          :total="total"
          @current-change="handleCurrentChange"
        />
      </div> -->
    </div>
    <AddressForm ref="address-form" @success="queryAddressList"/>
  </el-card>
</template>

<script>
import { commonUtils } from '@/utils/common'
import AddressForm from './components/address-form'
import userApi from '@/api/user'
export default {
  name: 'address-list',
  components: {
    AddressForm
  },
  data () {
    return {
      // sdList: [],
      total: null,
      queryParam: {
        page: 1,
        pageSize: 4
      },
      listLoading: false,
      addressList: [],
      orderAddressList: []
    }
  },
  created () {
    this.queryAddressList()
    // this.queryAddressList()
  },
  methods: {
    maskMobileNo: commonUtils.maskMobileNo,

    // 获取地址列表
    queryAddressList () {
      this.listLoading = true
      userApi.getAddressList(this.queryParam).then(res => {
        if (res.data.resultCode === '0') {
          this.listLoading = false
          this.addressList = res.data.resultData.addressList || []
          this.total = res.data.resultData.pageInfo.totalCounts
        }
      }).catch(() => {
        this.listLoading = false
      })
    },
    handleCurrentChange (val) {
      this.queryParam.page = val
      this.queryAddressList()
    },
    // handleFilter () {
    //   this.querySdAddress()
    // },

    // queryAddressList () {
    //   this.listLoading = true
    //   userApi.queryAddressList().then(res => {
    //     if (res.data.resultCode === '0') {
    //       this.listLoading = false
    //       this.addressList = res.data.resultData.addressList || []
    //       if (this.addressList.length) {
    //         this.addressSelected = this.addressList[0]
    //         this.orderAddressList.push(this.addressSelected)
    //       }
    //     }
    //   })
    // },
    composeAddressInfo (address) {
      if (!address) {
        return
      }
      let showInfo = ''
      showInfo += address.provinceName ? address.provinceName : ''
      showInfo += address.cityName ? (', ' + address.cityName) : ''
      showInfo += address.countyName ? (', ' + address.countyName) : ''
      showInfo += address.detailAddress ? (', ' + address.detailAddress) : ''
      return showInfo
    },
    showAddressCreate () {
      const addressForm = { action: 'create' }
      this.$refs['address-form'].show(addressForm)
    },
    showAddressUpdate (address) {
      const addressForm = Object.assign({ action: 'update' }, address)
      this.$refs['address-form'].show(addressForm)
    },
    removeAddress (address) {
      this.$confirm('是否删除收货地址?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        userApi.removeAddress(address).then(response => {
          if (response.data.resultCode === '0') {
            this.queryAddressList()
            this.$message.success('收货地址删除成功')
          }
        })
      }).catch(() => {})
    },
    setDefault (address) {
      if (address.isDefault) {
        return
      }
      this.$confirm('是否设置为默认地址?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        address.isDefault = 1
        userApi.updateAddress(address).then(response => {
          if (response.data.resultCode === '0') {
            this.queryAddressList()
            this.$message.success('设置默认地址成功')
          }
        })
      }).catch(() => {})
    }
  }
}
</script>

<style lang="scss" scoped>
.btn-create {
  float: right;
  margin-top: -6px;
}
.address-list {
  padding: 30px;
  .address-card {
    padding: 16px 24px;
    min-height: 80px;
    margin-bottom: 20px;
    ::v-deep .el-card__body {
      padding: 0;
      min-height: 80px;
    }
    .address-info {
      line-height: 28px;
    }
    .address-opt {
      padding: 24px 0 0 16px;
    }
  }
  .address-default {
    background-color: $base-grey3;
  }
}
</style>
